import React from 'react';
import { AlertTriangle } from 'lucide-react';

// Shared warning dialog used before any soft-delete (single or bulk) across
// Workshops, Lab Requests, Private Delivery Requests, and Syndication Requests.
// Deleted items always land in the "Deleted Items" trash for 30 days.
export const ConfirmDeleteModal = ({ open, title, itemCount = 1, onCancel, onConfirm, deleting }) => {
  if (!open) return null;
  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-[60] p-4" data-testid="confirm-delete-modal">
      <div className="bg-white rounded-2xl shadow-2xl max-w-md w-full">
        <div className="p-6">
          <div className="flex items-center gap-3 mb-3">
            <div className="w-10 h-10 rounded-full bg-red-100 flex items-center justify-center flex-shrink-0">
              <AlertTriangle size={20} className="text-red-600" />
            </div>
            <h3 className="text-lg font-bold text-gray-900">{title || 'Delete item?'}</h3>
          </div>
          <p className="text-sm text-gray-600 mb-3">
            Are you sure you want to delete {itemCount > 1 ? `these ${itemCount} items` : 'this item'}?
          </p>
          <p className="text-xs text-amber-700 bg-amber-50 border border-amber-200 rounded-lg px-3 py-2">
            {itemCount > 1 ? `${itemCount} items` : 'This item'} will be moved to <strong>Deleted Items</strong> and can be restored by an admin within 30 days, after which it is permanently removed.
          </p>
        </div>
        <div className="flex gap-3 p-6 pt-0">
          <button
            onClick={onCancel}
            disabled={deleting}
            className="flex-1 py-2 border border-gray-300 text-gray-700 rounded-lg text-sm font-medium hover:bg-gray-50 disabled:opacity-50"
            data-testid="confirm-delete-cancel-btn"
          >
            Cancel
          </button>
          <button
            onClick={onConfirm}
            disabled={deleting}
            className="flex-1 py-2 bg-red-600 text-white rounded-lg text-sm font-semibold hover:bg-red-700 disabled:opacity-60 flex items-center justify-center gap-2"
            data-testid="confirm-delete-confirm-btn"
          >
            {deleting ? (
              <><div className="animate-spin w-4 h-4 border-2 border-white border-t-transparent rounded-full" />Deleting...</>
            ) : (
              `Delete ${itemCount > 1 ? `(${itemCount})` : ''}`
            )}
          </button>
        </div>
      </div>
    </div>
  );
};
